const CloseIcon = () => (
  <svg width="26" height="27" viewBox="0 0 26 27" fill="none">
    <rect
      width="1.8662"
      height="34.5247"
      rx="0.9331"
      transform="matrix(-0.710061 0.70414 -0.710061 -0.70414 26.001 25.1377)"
      fill="currentColor"
    />
    <rect
      width="1.8662"
      height="34.5247"
      rx="0.9331"
      transform="matrix(0.710061 0.70414 -0.710061 0.70414 24.5146 1.20312)"
      fill="currentColor"
    />
  </svg>
)

export default CloseIcon
